import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { CommonModule } from '@angular/common';
import { DpBottomSheetCloserComponent } from "../../common-component/dp-bottom-sheet-closer/dp-bottom-sheet-closer.component";
import { LoaderComponent } from "../../common-component/loader/loader.component";
interface User {
  memberName: string;
  philName: string;
  lastIvDate: string;
  rs: string;
  st:string;
  dn:string,
  mk:string,
}
@Component({
  selector: 'app-are-you-updated-bottom-sheet',
  standalone: true,
  imports: [CommonModule, DpBottomSheetCloserComponent],
  templateUrl: './are-you-updated-bottom-sheet.component.html',
  styleUrl: './are-you-updated-bottom-sheet.component.scss'
})
export class AreYouUpdatedBottomSheetComponent {
  users: User[] = [];

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<AreYouUpdatedBottomSheetComponent>
) {}

  ngOnInit(): void {
    this.users = this.data;
    console.log(this.users)
  }

  closesheet():void{
    this.bottomSheetRef.dismiss();
  }
}
